var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      [
        _vm.session.contents
          ? [
              _c(
                "h3",
                [_c("router-link", { attrs: { to: "/" } }, [_vm._v("Home")])],
                1
              ),
              _vm._v(" "),
              _c(
                "h3",
                [
                  _c("router-link", { attrs: { to: "/profile" } }, [
                    _vm._v("Profile")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "h3",
                {
                  on: {
                    click: function($event) {
                      _vm.logout()
                    }
                  }
                },
                [_vm._v("Logout")]
              )
            ]
          : [
              _c(
                "h3",
                [
                  _c("router-link", { attrs: { to: "/login" } }, [
                    _vm._v("Login")
                  ])
                ],
                1
              )
            ]
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h2", [_vm._v("Anvil")]),
      _vm._v(" "),
      _c("h3", [_vm._v("Link 1")]),
      _vm._v(" "),
      _c("h3", [_vm._v("Link 2")]),
      _vm._v(" "),
      _c("h3", [_vm._v("Link 3")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29e8c3c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29e8c3c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = CJVD
// module chunks = 1